import {
  UpdateRestoreStatusMap,
  UpdateUpgradeStatusMap,
} from 'services/pangolin/protos/update_pb';

export enum IPCMessageKind {
  INITIATE_REQUEST = 1,
  RESOLVE_REQUEST = 2,
  REJECT_REQUEST = 3,
  TOGGLE_REFRESH = 4,
  FCM_TOKEN_REFRESH = 5,
  FCM_MESSAGE = 6,
  FCM_MESSAGE_OPEN = 7,
}

export type IPCMessage =
  | { kind: IPCMessageKind.INITIATE_REQUEST; request: NativeRequest }
  | { kind: IPCMessageKind.RESOLVE_REQUEST; response: NativeResponse }
  | { kind: IPCMessageKind.REJECT_REQUEST; requestID: string; reason?: string }
  | { kind: IPCMessageKind.TOGGLE_REFRESH; refreshEnabled: boolean }
  | { kind: IPCMessageKind.FCM_TOKEN_REFRESH; token: string }
  | { kind: IPCMessageKind.FCM_MESSAGE; message: FCMMessage }
  | { kind: IPCMessageKind.FCM_MESSAGE_OPEN; message: FCMMessage };

export enum NativeRequestKind {
  RELOAD_DATA = 1,
  HISTORY_CHECK = 2,
  QR_CODE = 3,
  FCM_TOKEN = 4,
  CLIPBOARD_SET = 5,
}

export type ReloadDataNativeRequest = {
  kind: NativeRequestKind.RELOAD_DATA;
  id: string;
};

export type ReloadDataNativeResponse = {
  kind: NativeRequestKind.RELOAD_DATA;
  id: string;
  success: boolean;
};

export type HistoryCheckNativeRequest = {
  kind: NativeRequestKind.HISTORY_CHECK;
  id: string;
};

export type HistoryCheckNativeResponse = {
  kind: NativeRequestKind.HISTORY_CHECK;
  id: string;
  canGoBack: boolean;
};

export type QRCodeNativeRequest = {
  kind: NativeRequestKind.QR_CODE;
  id: string;
};

export type QRCodeNativeResponse = {
  kind: NativeRequestKind.QR_CODE;
  id: string;
  qrCode: string;
};

export type FCMTokenNativeRequest = {
  kind: NativeRequestKind.FCM_TOKEN;
  id: string;
};

export type FCMTokenNativeResponse = {
  kind: NativeRequestKind.FCM_TOKEN;
  id: string;
  token: string;
};

export type ClipboardSetRequest = {
  kind: NativeRequestKind.CLIPBOARD_SET;
  id: string;
  value: string;
};

export type ClipboardSetResponse = {
  kind: NativeRequestKind.CLIPBOARD_SET;
  id: string;
  success: true;
};

export type NativeRequest =
  | QRCodeNativeRequest
  | HistoryCheckNativeRequest
  | ReloadDataNativeRequest
  | FCMTokenNativeRequest
  | ClipboardSetRequest;

export type NativeResponse =
  | QRCodeNativeResponse
  | HistoryCheckNativeResponse
  | ReloadDataNativeResponse
  | FCMTokenNativeResponse
  | ClipboardSetResponse;

export enum FCMMessageKind {
  HOST_CONNECTED = 1,
  NEW_INCIDENT = 2,
  ONLINE_STATUS_UPDATE = 3,
  UPGRADE_STATUS_UPDATE = 4,
  RESTORE_STATUS_UPDATE = 5,
}

export type FCMMessage =
  | { kind: FCMMessageKind.HOST_CONNECTED; messageID?: string; pangolinID: string; hostID: string }
  | { kind: FCMMessageKind.NEW_INCIDENT; messageID?: string; pangolinID: string; issueID: string; incidentID: string }
  | { kind: FCMMessageKind.ONLINE_STATUS_UPDATE; messageID?: string; pangolinID: string; onlineStatus: boolean }
  | { kind: FCMMessageKind.UPGRADE_STATUS_UPDATE; messageID?: string; pangolinID: string; upgradeID: string; upgradeStatus: UpdateUpgradeStatusMap[keyof UpdateUpgradeStatusMap] }
  | { kind: FCMMessageKind.RESTORE_STATUS_UPDATE; messageID?: string; pangolinID: string; restoreID: string; restoreStatus: UpdateRestoreStatusMap[keyof UpdateRestoreStatusMap] };
